const baseURL = "https://api.punkapi.com/v2/beers?page=1&per_page=60";
const abv_gt = "https://api.punkapi.com/v2/beers?page=1&per_page=60&abv_gt=";
const abv_lt = "https://api.punkapi.com/v2/beers?page=1&per_page=60&abv_lt=";

export { baseURL, abv_gt, abv_lt };
